import { AxiosResponse } from "axios";
import { Base2DApi } from "../Base2DApi";
import { IRenderConfigImageResponse, IRenderConfigurationData } from "./type";
import { ENDPOINTS } from "../../../../processes/api/endpoints";

export class ConfigurationApi extends Base2DApi {
  public async renderConfiguration(
    data: IRenderConfigurationData
  ): Promise<AxiosResponse<IRenderConfigImageResponse>> {
    return this.axiosInstance.post(
      ENDPOINTS.CONFIGURATION.RENDER_2D_CONFIGURATION,
      data
    );
  }
}
